module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mt-2"
  }, [_c('h3', [_vm._v("Promotions")]), _vm._v(" "), _vm._l((_vm.promotions), function(coupon) {
    return _c('toggle', {
      key: coupon.id,
      attrs: {
        "data": coupon,
        "action": _vm.toggleCoupon
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc48a07a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shop/Coupons.vue
// module id = 274
// module chunks = 1